import { useEffect } from "react";

interface Props {
	ref: React.RefObject<HTMLElement>;
	handler: () => void;
}

const useOutsideClick = (props: Props) => {
	const { ref, handler } = props;

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent) => {
			if (ref.current && !ref.current.contains(event.target as Node)) {
				handler();
			}
		};

		document.addEventListener("mousedown", handleClickOutside);

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [ref, handler]);
};

export default useOutsideClick;
